import React from 'react';
import { Message, MessageLevel } from 'containers/InteractiveArea/Message';
import MessageResponseEntry from 'containers/InteractiveArea/MessageResponseEntry';
import { animated as a, useTransition } from 'react-spring';
import { MessageCancel, MessageInfo, MessageInfoLight } from './Messages';
import MessageModal from '../MessageModal';

interface Props {
  message: Message;
  style: any;
}

const MessageEntry = ({ message, style }: Props) => {
  const transitions = useTransition(
    message.responses,
    message => message.content,
    {
      from: { transform: 'translateX(100%)' },
      enter: { transform: 'translateY(0%)' },
      leave: { opacity: 0 },
      trail: 200,
    },
  );

  const getMessage = () => {
    if (message.level === MessageLevel.Cancel) {
      return <MessageCancel message={message} />;
    }
    if (message.responses && message.responses.length > 0) {
      return <MessageInfo message={message} />;
    }
    return <MessageInfoLight message={message} />;
  };

  if (message.modal) {
    return <MessageModal message={message} />;
  }
  return (
    <div className="my-4" style={style}>
      <div className="message flex justify-start">{getMessage()}</div>
      <div className="flex flex-row lg:flex-col overflow-auto overflow-hidden ">
        {transitions.map(({ item, props, key }) => (
          <a.div
            key={key}
            className="message-response flex justify-end "
            style={props}
          >
            <MessageResponseEntry response={item} />
          </a.div>
        ))}
      </div>
    </div>
  );
};

export default MessageEntry;
